module.exports = __webpack_public_path__ + "img/moderation_DrThummGmbH_RZ_RGB.271a3e00.png";